document.addEventListener("click", function(e){
  const pdfContainer = e.target.closest(".pdf-download");
  if(!pdfContainer) return;

  e.preventDefault();
  e.stopPropagation();

  // Find the actual link element (either .pdf-download itself or a link inside it)
  const link = pdfContainer.tagName === 'A' ? pdfContainer : pdfContainer.querySelector('a');
  if(!link || !link.href) {
    console.warn('PDF download: No valid link found');
    return;
  }

  // Get the href - handle both href attribute and property
  const pdfUrl = link.getAttribute('href') || link.href;
  if(!pdfUrl) {
    console.warn('PDF download: No href found');
    return;
  }

  // Get filename from URL or use default
  const filename = pdfUrl.split('/').pop().split('?')[0] || 'download.pdf';

  // Fetch the PDF and create a blob URL for cross-origin downloads
  fetch(pdfUrl)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.blob();
    })
    .then(blob => {
      // Create blob URL
      const blobUrl = window.URL.createObjectURL(blob);
      
      // Create download link
      const downloadLink = document.createElement("a");
      downloadLink.href = blobUrl;
      downloadLink.setAttribute("download", filename);
      downloadLink.style.display = "none";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      
      // Clean up
      setTimeout(function() {
        document.body.removeChild(downloadLink);
        window.URL.revokeObjectURL(blobUrl);
      }, 100);
    })
    .catch(error => {
      console.error('PDF download error:', error);
      // Fallback: try direct download (may not work for cross-origin)
      const downloadLink = document.createElement("a");
      downloadLink.href = pdfUrl;
      downloadLink.setAttribute("download", filename);
      downloadLink.setAttribute("target", "_blank");
      downloadLink.style.display = "none";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      setTimeout(function() {
        document.body.removeChild(downloadLink);
      }, 100);
    });
});